import { Component } from '@angular/core';

@Component({
  selector: 'app-responsible-company',
  templateUrl: './responsible-company.component.html',
  styleUrl: './responsible-company.component.scss'
})
export class ResponsibleCompanyComponent {
  header = {
    badge: 'Nuestro Compromiso',
    title: 'Somos una Empresa Socialmente Responsable',
    description: 'Entendemos que la construcción va más allá de edificar obras: implica crear valor para la sociedad, cuidar el entorno y actuar con ética en cada proyecto que desarrollamos.'
  };

  decorativeImage = {
    src: 'assets/images/home/responsible.png',
    alt: 'Responsabilidad Social Empresarial'
  };

  principles = [
    {
      title: 'Compromiso Ambiental',
      description: 'Implementamos prácticas sostenibles en todos nuestros proyectos para minimizar el impacto ambiental.',
      iconPath: 'M22 12h-4l-3 9L9 3l-3 9H2'
    },
    {
      title: 'Desarrollo Local',
      description: 'Promovemos el empleo local y colaboramos con proveedores de la región donde trabajamos.',
      iconPaths: [
        'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2',
        'M22 21v-2a4 4 0 0 0-3-3.87',
        'M16 3.13a4 4 0 0 1 0 7.75'
      ],
      iconCircle: { cx: '9', cy: '7', r: '4' }
    },
    {
      title: 'Capacitación Continua',
      description: 'Invertimos en el desarrollo profesional de nuestro equipo y comunidades cercanas.',
      iconPaths: [
        'M12 2L2 7l10 5 10-5-10-5z',
        'M2 17l10 5 10-5',
        'M2 12l10 5 10-5'
      ]
    },
    {
      title: 'Bienestar Laboral',
      description: 'Garantizamos condiciones laborales dignas y un ambiente de trabajo seguro para todos.',
      iconPolyline: '22 12 18 12 15 21 9 3 6 12 2 12'
    }
  ];
} 